function getFileExt(file) {
    var extRegex = /(?:\.([^.]+))?$/;
    return extRegex.exec(file)[1];
}

export default getFileExt;
